export default __webpack_public_path__ + "static/media/published-book.00c5ee5b.svg";